export default {
    uiv: {
      datePicker: {
        clear: 'Clear',
        today: 'Today',
        month: 'Month',
        month1: 'January',
        month2: 'February',
        month3: 'March',
        month4: 'April',
        month5: 'May',
        month6: 'June',
        month7: 'July',
        month8: 'August',
        month9: 'September',
        month10: 'October',
        month11: 'November',
        month12: 'December',
        year: 'Year',
        week1: 'Mon',
        week2: 'Tue',
        week3: 'Wed',
        week4: 'Thu',
        week5: 'Fri',
        week6: 'Sat',
        week7: 'Sun'
      },
      timePicker: {
        am: 'AM',
        pm: 'PM'
      },
      modal: {
        cancel: 'Cancel',
        ok: 'OK'
      },
      multiSelect: {
        placeholder: 'Select...',
        filterPlaceholder: 'Search...'
      }
    }
  }